import { isAxiosError } from 'axios'
import config from '../config'

// TODO: Test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const objToQueryString = (obj: { [key: string]: any }): string => {
  const keyValuePairs: string[] = []
  Object.keys(obj).forEach((key) => {
    keyValuePairs.push(
      `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
    )
  })
  return keyValuePairs.join('&')
}

export const createUrl = (
  path: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parameters?: { [key: string]: any }
): string => {
  return `${config.BASE_URL}${path}?${
    parameters ? objToQueryString(parameters) : ''
  }`
}

export const convertBase64 = (
  file: File | Blob
): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result)
    }
    fileReader.onerror = (error) => {
      reject(error)
    }
  })
}

export const definedParams = (query: {
  [key: string]: string | number | boolean | undefined
}): { [key: string]: string | number | boolean } =>
  Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== undefined)
  ) as { [key: string]: string | number | boolean }

const statusOf = (error: unknown): number | undefined =>
  isAxiosError(error) ? error.response?.status : undefined

export const isRefusedRequest = (error: unknown): boolean => {
  const status = statusOf(error)
  return status === 400 || status === 403 || status === 404
}

export const isDeniedRequest = (error: unknown): boolean => {
  const status = statusOf(error)
  return status === 403 || status === 404
}

export const isParentDenied = (error: unknown, target?: string): boolean => {
  const status = statusOf(error)
  return status === 403 || (status === 404 && target === undefined)
}
